var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('ol', {
    attrs: {
      "id": "tallyMark"
    }
  }, [_vm._l(JSON.parse(_vm.value), function (index) {
    return _c('li', {
      key: index
    });
  }), _vm._v("\n     \n  ")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }